import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { Hero } from '@/components/sections/Hero';
import { WhatIsAppMap } from '@/components/sections/WhatIsAppMap';
import SocialProof from '@/components/sections/SocialProof';
import { FeaturesReview } from '@/components/sections/FeaturesReview';
import { RealBehaviorDemo } from '@/components/sections/RealBehaviorDemo';
import { BiggerPictureDemo } from '@/components/sections/BiggerPictureDemo';
import { ApplicationRunsDemo } from '@/components/sections/ApplicationRunsDemo';
import { MissingContextDemo } from '@/components/sections/MissingContextDemo';
import { RuntimeContextDemo } from '@/components/sections/RuntimeContextDemo';
import { FinalCTA } from '@/components/sections/FinalCTA';

export function Index() {

  return (
    <>
      <Helmet>
        <title>AppMap | AppMap</title>
        <meta name="description" content="Cutting edge AI for challenging dev work. Dev-centric observability + AI delivers the smartest answers in your code editor." />
        <meta name="author" content="getappmap" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="AppMap" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:description" content="Cutting edge AI for challenging dev work. Dev-centric observability + AI delivers the smartest answers in your code editor." />
        <meta property="og:url" content="https://appmap.io/" />
        <meta property="og:site_name" content="AppMap" />
        <meta property="og:image" content="https://appmap.io/assets/img/logos/1200x630-appmap-card.png" />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:image" content="https://appmap.io/assets/img/logos/1200x630-appmap-card.png" />
        <meta property="twitter:title" content="AppMap" />
        <meta name="twitter:site" content="@getappmap" />
        <meta name="twitter:creator" content="@getappmap" />
      </Helmet>
      
      <div className="min-h-screen bg-gray-900">
        <Header />
        <Hero />
        <WhatIsAppMap />
        <SocialProof />
        <FeaturesReview />
        <RealBehaviorDemo />
        <BiggerPictureDemo />
        <ApplicationRunsDemo />
        <MissingContextDemo />
        <RuntimeContextDemo />
        <FinalCTA />
      </div>
    </>
  );
}